import React from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';

// Hooks
import { useGoalDetailPanel } from 'Shared/utils/hooks/use-goal-detail-panel';

// Types
import { User, GoalItem } from 'Shared/constants/types';

// Components
import UserDataContainer from 'Shared/components/UserDataContainer/UserDataContainer';
import GoalsCardContainer from 'Shared/components/Goals/GoalsCardContainer/GoalsCardContainer';
import GoalsTable, { GoalTableColumns } from './GoalsTable/GoalsTable';

type Props = {
  user: User;
  goals: GoalItem[];
};

const UserGoalsContainer = ({ user, goals }: Props) => {
  const { featureFlagGoalsVersion3: showNewGoals } = useFlags();
  const { handleOpenPanel } = useGoalDetailPanel();
  // if there are goals in the filter, do not render component
  if (goals.length === 0) {
    return null;
  }

  const handleClick = (goal: GoalItem) => {
    handleOpenPanel(goal.slug);
  };

  return (
    <UserDataContainer user={user}>
      {showNewGoals ? (
        <GoalsTable
          goals={goals}
          hiddenColumns={[
            GoalTableColumns.owner,
            GoalTableColumns.workspace,
            GoalTableColumns.department,
            GoalTableColumns.actions,
          ]}
          onRowClick={handleClick}
        />
      ) : (
        <GoalsCardContainer goals={goals} />
      )}
    </UserDataContainer>
  );
};

export default UserGoalsContainer;
